;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { ReactNode } from "react";
import styles from "./Badge.module.scss";
export interface BadgeProps {
  children: ReactNode;
  style?:
    "yellow" |
    "green" |
    "teal" |
    "passport" |
    "red" |
    "coral" |
    "coral_midnight" |
    "teal_midnight" |
    "live" |
    "yellow_outline" |
    "teal_outline" |
    "passport_outline" |
    "red_outline" |
    "yellow_darken";
  className?: string;
}

const Badge = (props: BadgeProps) => {
  const { children, style = "yellow", className } = props;

  let classNames = `${styles[style]}`;

  if (className) {
    classNames += ` ${className}`;
  }

  return (
    <span className={classNames}>
      {children}
    </span>
  );
}

export default Badge;
